import React from 'react'
import styles from './Header.module.css'
import { NavLink } from 'react-router-dom'
import logo from '../Assets/logocantinho.png'


const Header = () => {
  return (
    <nav className={styles.header}>
      <ul >
        <li>
          <NavLink  to="/"><img className={`${styles.logo} ${styles.button}`} src={logo} alt=""  /></NavLink>
        </li>
        <li>
          <NavLink activeClassName={styles.active} className={styles.link} to="/" end>Produtos</NavLink>
        </li>
        <li>
          <NavLink activeClassName={styles.active} className={styles.link} to="contato">Contato</NavLink>
        </li>
      </ul>
    </nav>
  )
}

export default Header
